import { render } from "./IzinView.vue?vue&type=template&id=0b94d27c"
import script from "./IzinView.vue?vue&type=script&lang=js"
export * from "./IzinView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__